<template>
  <div class="wrapper">
    <div class="searchBar">
      <div>
        <el-input
          placeholder="身份证"
          v-model="searchCondition.idCard"
          size="small"
          style="width: 160px"
        ></el-input>
        <el-input
          placeholder="手机号"
          v-model="searchCondition.mobile"
          size="small"
          style="width: 160px"
        ></el-input>
      </div>
      <div>
        <el-button type="primary" size="small" @click="getData">查询</el-button>
      </div>
    </div>
    <div class="content">
      <div class="tableContainer">
        <el-table
          :data="dataList"
          border
          style="width: 100%"
          :cell-style="{ padding: '8px 0', fontSize: '14px' }"
        >
          <el-table-column prop="userName" label="姓名"> </el-table-column>
          <el-table-column prop="mobile" label="手机号"> </el-table-column>
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { openInvoice } from "@/api/bus.js";
export default {
  data() {
    return {
      dataList: [],
      searchCondition: {
        mobile: "",
        idCard: "",
      },
    };
  },
  created() {},
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      openInvoice(this.searchCondition).then((data) => {
        console.log(data);
      });
    },
  },
};
</script>

<style scoped lang="less">
.wrapper {
  .searchBar {
    padding: 15px;
    background: #fff;
    display: flex;
    justify-content: space-between;
  }
  .content {
    margin-top: 15px;
    background: #fff;
    padding: 15px;
    .actBar {
      margin-bottom: 10px;
    }
  }
}
</style>
